import Button from "@edaz/edazkit/Button/index";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { IconType } from "@edaz/edazkit/Icon";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { translateGeneral } from "utils/localizations";
import ExpensesReportsViewModel from "viewModels/finance/expensesAndRevenuesReports/expensesReportsViewModel";
import FormLabel from "controls/formLabel";
import { busyIdentificator } from "utils/busyWatcher";

const ExpensesReportsView: ViewComponent<ExpensesReportsViewModel> = observer(({ vm }) => {
  const isDownloadBusy = vm.busyWatcher.checkBusy(busyIdentificator([vm.selectedMonth]));

  return (
    <>
      <Form className="mb-4" onSubmit={preventDefault(vm.onFormSubmit)}>
        <Row>
          <Col as={Form.Group} md={6} lg={4}>
            <FormLabel required={true}>{vm.translate("date")}</FormLabel>
            <AdvancedSelect target={vm} property="selectedDate" items={vm.months} placeholder={translateGeneral("select")} />
          </Col>
          <Col md="auto">
            <Button
              className="mt-md-5 rounded d-block"
              disabled={isDownloadBusy || !vm.selectedMonth}
              type="submit"
              iconLeft={isDownloadBusy ? IconType.Spinner : IconType.Download}>
              {translateGeneral("download")}
            </Button>
          </Col>
        </Row>
      </Form>
      <div className="mt-4">
        <table className="table table-striped table-full">
          {vm.items.map(item => {
            const month = item.month;
            const isBusy = vm.busyWatcher.checkBusy(busyIdentificator([month]));

            return (
              <tr key={item.id.toString()}>
                <td>
                  <strong>{item.label}</strong>
                </td>
                <td className="text-align-end">
                  <Button
                    variant="success"
                    size="sm"
                    className="rounded"
                    disabled={isBusy}
                    iconLeft={isBusy ? IconType.Spinner : IconType.Download}
                    onClick={() => vm.onDownloadClick(month)}>
                    {translateGeneral("download")}
                  </Button>
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
});

registerView(ExpensesReportsView, ExpensesReportsViewModel);
